<template>
  <!-- A Tài Xỉu market as an icon badge (utils/tai-xiu-market.ts). -->
  <span :class="['tx-market-badge', `tx-market-badge--${market.kind}`]">
    <!-- Total: the three-dot mark and the total (Figma 457:7859). -->
    <template v-if="market.kind === 'total'">
      <i class="tx-market-badge__dots" aria-hidden="true"><b /><b /><b /></i>
      <strong>{{ market.value }}</strong>
    </template>
    <!-- Single / double / triple: the face, once, twice or three times. -->
    <template v-else>
      <img
        v-for="(face, index) in market.faces"
        :key="index"
        class="tx-market-badge__die"
        :src="diceImage(face)"
        :alt="`Die ${face}`"
      />
    </template>
  </span>
</template>

<script>
export default {
  name: 'TxMarketBadge',
  props: {
    // From `taiXiuIconMarket`: { kind: 'total', value } or { kind: 'dice', faces }.
    market: {
      type: Object,
      required: true,
    },
  },
  methods: {
    diceImage(face) {
      return require(`@/assets/svg/dice-items/dice-${face}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
// Sampled from the Figma badge (457:7859).
$gold: #eec87f;

.tx-market-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  vertical-align: middle;
}

// Total: 33x25, navy with a 1px gold rim, the gold mark and the total in white.
.tx-market-badge--total {
  min-width: 33px;
  height: 25px;
  padding: 0 6px;
  gap: 4px;
  border: 1px solid $gold;
  border-radius: 6px;
  background: linear-gradient(180deg, #213260, #23386e);
  color: #fff;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;

  strong {
    font-weight: 800;
  }
}

// The three-dot mark, 10x10.
.tx-market-badge__dots {
  position: relative;
  width: 10px;
  height: 10px;
  flex: 0 0 auto;
  display: block;

  b {
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: $gold;

    &:nth-child(1) {
      top: 0;
      left: 3px;
    }

    &:nth-child(2) {
      bottom: 0;
      left: 0;
    }

    &:nth-child(3) {
      bottom: 0;
      right: 0;
    }
  }
}

// Single / double / triple: the faces themselves, no pill behind them.
.tx-market-badge--dice {
  gap: 2px;
}

// Smaller than the bet board's face buttons (20px), so a triple fits the table.
.tx-market-badge__die {
  width: 16px;
  height: 16px;
  display: block;
}
</style>
